import { render, staticRenderFns } from "./valueitem.vue?vue&type=template&id=0a0a5472&"
import script from "./valueitem.vue?vue&type=script&lang=js&"
export * from "./valueitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports